import React, { useState, useEffect, useCallback } from "react";
import Header from "../components/organisms/Header";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  convertTimeTo24,
  getRouteSegment,
  timezoneTimeToUtc,
  utcTimeToTimezone,
} from "../lib/utils/funcs";
import {
  getSettingsByHospitalId,
  putSettingsByHospitalId,
} from "../lib/apis/adminpanel";
import CustomSelect from "../components/atoms/CustomSelect";
import { getCookie, setCookie } from "../lib/utils/cookies";
import moment from "moment-timezone";
import { useFeatureFlags } from "../lib/contexts/FeatureFlagContext";

const AdminPanel: React.FC = () => {
  const [doctorToggle, setDoctorToggle] = useState(false);
  const [reminder1, setReminder1] = useState("off");
  const [reminder2, setReminder2] = useState("off");
  const [reminder3, setReminder3] = useState("off");
  const [isLoading, setIsLoading] = useState(false);
  const hospital_id = getRouteSegment(1);
  const { admin_panel } = useFeatureFlags();

  const [preToggle, setPreToggle] = useState(false);
  const [preReminder, setPreReminder] = useState("off");

  const [dayBeforeToggle, setDayBeforeToggle] = useState(false);
  const [dayBeforeTiming, setDayBeforeTiming] = useState("off");

  const [noShowToggle, setNoShowToggle] = useState(false);
  const [noShowReminder, setNoShowReminder] = useState("off");

  const [followUpToggle, setFollowUpToggle] = useState(false);
  const [followUpReminder, setFollowUpReminder] = useState("off");

  const [dailyReportToggle, setDailyReportToggle] = useState(false);
  const [dailyReportTiming, setDailyReportTiming] = useState("off");

  const [doctorDelayToggle, setDoctorDelayToggle] = useState(false);

  const [checkQueueToggle, setCheckQueueToggle] = useState(false);

  const [userDistanceToggle, setUserDistanceToggle] = useState(false);
  const [userDistanceTiming, setUserDistanceTiming] = useState("off");

  const [autoCompleteToggle, setAutoCompleteToggle] = useState(false);
  const [autoCompleteTiming, setAutoCompleteTiming] = useState("off");

  const [googleReviewToggle, setGoogleReviewToggle] = useState(true);
  const [customReview, setCustomReview] = useState(0);

  const [doctorDailyReportToggle, setDoctorDailyReportToggle] = useState(false);
  const [doctorReportTiming, setDoctorReportTiming] = useState("off");

  const [appointmentCancellationToggle, setAppointmentCancellationToggle] =
    useState(false);
  const [appointmentReasonToggle, setAppointmentReasonToggle] = useState(false);

  const [samedayBotbookingDisableToggle, setSamedayBotbookingDisableToggle] =
    useState(false);
  const [samedayBotbookingDisableTime, setSamedayBotbookingDisableTime] =
    useState("off");
  const [unavailableDocMessageToggle, setUnavailableDocMessageToggle] =
    useState(false);
  const samedayBotbookingDisableTimeOptions = [
    "4 am",
    "5 am",
    "6 am",
    "7 am",
    "8 am",
    "9 am",
    "10 am",
    "11 am",
    "12 pm",
    "1 pm",
    "2 pm",
    "3 pm",
    "4 pm",
    "5 pm",
    "6 pm",
    "7 pm",
    "8 pm",
    "9 pm",
    "10 pm",
    "11 pm",
  ];

  const [timeZone, setTimeZone] = useState(
    getCookie("timezone") || "Asia/Kolkata"
  );
  // const [confirmWithoutCancelToggle, setConfirmWithoutCancelToggle] =
  //   useState(false);

  const [generalInstructionsToggle, setGeneralInstructionsToggle] = useState(false);
  const [generalInstructions, setGeneralInstructions] = useState<{ [lang: string]: string }>({ en: "" });
  const [selectedInstructionLang, setSelectedInstructionLang] = useState("en");

  // Visit Type Instructions — { lang: { visitType: text } }
  const visitTypes = ["booking_new", "booking_followup", "walkin_new", "walkin_followup", "video_new", "video_followup"] as const;
  const visitTypeLabels: Record<string, string> = {
    booking_new: "Booking - New",
    booking_followup: "Booking - Follow-up",
    walkin_new: "Walk-in - New",
    walkin_followup: "Walk-in - Follow-up",
    video_new: "Video - New",
    video_followup: "Video - Follow-up",
  };
  const [visitTypeInstructions, setVisitTypeInstructions] = useState<{ [lang: string]: { [vt: string]: string } }>({ en: {} });
  const [selectedVisitType, setSelectedVisitType] = useState("booking_new");
  const [selectedVTLang, setSelectedVTLang] = useState("en");

  // Move textareaRef and effect to top level
  const textareaRef = React.useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  }, [generalInstructions[selectedInstructionLang]]);

  // Handler for textarea change
  const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    // Remove newlines from input
    const val = e.target.value.replace(/[\r\n]+/g, ' ').slice(0, 200);
    setGeneralInstructions({ ...generalInstructions, [selectedInstructionLang]: val });
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  };

  // Prevent newlines on keydown and paste in textarea
  const handleTextareaKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  const handleTextareaPaste = (e: React.ClipboardEvent<HTMLTextAreaElement>) => {
    e.preventDefault();
    const text = e.clipboardData.getData('text/plain').replace(/[\r\n]+/g, ' ');
    const val = (generalInstructions[selectedInstructionLang] || '') + text;
    setGeneralInstructions({ ...generalInstructions, [selectedInstructionLang]: val.slice(0, 200) });
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  };

  // Add debounced toast function
  const debouncedToast = useCallback(() => {
    const toastId = "upgrade-plan-toast";
    if (!toast.isActive(toastId)) {
      toast.error("Please upgrade your plan to modify", {
        toastId: toastId,
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  }, []);

  const handleDisabledInteraction = () => {
    if (!admin_panel) {
      debouncedToast();
      return;
    }
  };

  const handleDoctorToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    if (doctorToggle) {
      setDoctorToggle(false);
    } else {
      setDoctorToggle(true);
    }
  };

  const handleReminder1Change = (value: string) => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setReminder1(value);
    setDoctorToggle(
      value !== "OFF" || reminder2 !== "OFF" || reminder3 !== "OFF"
    );
  };

  // const handleAppointmentWithoutCancelToggleChange = () => {
  //   if (!admin_panel) {
  //     handleDisabledInteraction();
  //     return;
  //   }
  //   setConfirmWithoutCancelToggle(!confirmWithoutCancelToggle);
  // };

  const handleDoctorDailyReportToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setDoctorDailyReportToggle(!doctorDailyReportToggle);

    if (!doctorDailyReportToggle) {
      setDoctorReportTiming("11 pm");
    }
  };

  const handleDoctorReportTimingChange = (value: string) => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    if (["7 pm", "8 pm", "9 pm", "10 pm", "11 pm"].includes(value)) {
      setDoctorReportTiming(value);
    }
  };

  const handleAppointmentCancellationToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setAppointmentCancellationToggle(!appointmentCancellationToggle);
  };

  const handleAppointmentReasonToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setAppointmentReasonToggle(!appointmentReasonToggle);
  };

  const handleSamedayBotbookingDisableToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setSamedayBotbookingDisableToggle(!samedayBotbookingDisableToggle);
    if (!samedayBotbookingDisableToggle) {
      setSamedayBotbookingDisableTime("8 am");
    }
  };

  const handleSamedayBotbookingDisableTimeChange = (value: string) => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    if (samedayBotbookingDisableTimeOptions.includes(value)) {
      setSamedayBotbookingDisableTime(value);
    }
  };

  const handleUnavailableDocMessageToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setUnavailableDocMessageToggle(!unavailableDocMessageToggle);
  };

  const handleReminder2Change = (value: string) => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setReminder2(value);
    setDoctorToggle(
      reminder1 !== "OFF" || value !== "OFF" || reminder3 !== "OFF"
    );
  };

  const handleReminder3Change = (value: string) => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setReminder3(value);
    setDoctorToggle(
      reminder1 !== "OFF" || reminder2 !== "OFF" || value !== "OFF"
    );
  };

  const handlePreToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    if (preToggle) {
      setPreToggle(false);
    } else {
      setPreToggle(true);
      if (preReminder === "off") {
        setPreReminder("30 min ");
      }
    }
  };

  const handlePreReminderChange = (value: string) => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setPreReminder(value);
    setPreToggle(value !== "off");
  };

  const handleGoogleReviewToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setGoogleReviewToggle(!googleReviewToggle);
  };

  const handleDayBeforeToggleChange = () => {
    console.log("Hello");

    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    if (dayBeforeToggle) {
      setDayBeforeToggle(false);
    } else {
      setDayBeforeToggle(true);
      if (dayBeforeTiming === "off") {
        setDayBeforeTiming("9 pm");
      }
    }
  };

  const handleDayBeforeTimingChange = (value: string) => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setDayBeforeTiming(value);
    setDayBeforeToggle(value !== "off");
  };

  const handleNoShowToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    if (noShowToggle) {
      setNoShowToggle(false);
    } else {
      setNoShowToggle(true);
      if (noShowReminder === "off") {
        setNoShowReminder("30 min");
      }
    }
  };

  const handleNoShowReminderChange = (value: string) => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setNoShowReminder(value);
    setNoShowToggle(value !== "off");
  };

  const handleFollowUpToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    if (followUpToggle) {
      setFollowUpToggle(false);
    } else {
      setFollowUpToggle(true);
      if (followUpReminder === "off") {
        setFollowUpReminder("6 am");
      }
    }
  };

  const handleFollowUpReminderChange = (value: string) => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setFollowUpReminder(value);
    setFollowUpToggle(value !== "off");
  };

  const handleDailyReportToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    if (dailyReportToggle) {
      setDailyReportToggle(false);
    } else {
      setDailyReportToggle(true);
      if (dailyReportTiming === "off") {
        setDailyReportTiming("11 pm");
      }
    }
  };

  const handleDailyReportTimingChange = (value: string) => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setDailyReportTiming(value);
    setDailyReportToggle(value !== "off");
  };

  const handleDoctorDelayToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setDoctorDelayToggle(!doctorDelayToggle);
  };

  const handleCheckQueueToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setCheckQueueToggle(!checkQueueToggle);
  };

  const handleAutoCompleteToggleChange = () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    if (autoCompleteToggle) {
      setAutoCompleteToggle(false);
    } else {
      setAutoCompleteToggle(true);
      if (autoCompleteTiming === "off") {
        setAutoCompleteTiming("30 min");
      }
    }
  };

  const handleAutoCompleteTimingChange = (value: string) => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setAutoCompleteTiming(value);
  };

  const handleSave = async () => {
    if (!admin_panel) {
      handleDisabledInteraction();
      return;
    }
    setIsLoading(true);
    // Prepare multilingual instructions for API
    let instructionSettings = undefined;
    if (generalInstructionsToggle) {
      // General instructions — flat: { en: "text", hi: "text" }
      const filtered = Object.entries(generalInstructions)
        .filter(([k, v]) => k && v && k.length <= 10 && v.length <= 200)
        .slice(0, 25);
      const instructionContent = filtered.length > 0 ? Object.fromEntries(filtered) : {};

      // Visit type instructions — { en: { booking_new: "...", ... }, hi: { ... } }
      const vtContent: Record<string, Record<string, string>> = {};
      Object.entries(visitTypeInstructions).forEach(([lang, vtData]) => {
        const filtered = Object.entries(vtData).filter(([, v]) => v && v.length <= 200);
        if (filtered.length > 0) {
          vtContent[lang] = Object.fromEntries(filtered);
        }
      });

      instructionSettings = {
        isInstructionNeeded: true,
        instructionContent: Object.keys(instructionContent).length > 0 ? instructionContent : null,
        visitTypeInstructionContent: Object.keys(vtContent).length > 0 ? vtContent : null,
      };
    } else {
      instructionSettings = {
        isInstructionNeeded: false,
        instructionContent: null,
        visitTypeInstructionContent: null,
      };
    }
    // Log General Instructions if enabled
    if (generalInstructionsToggle) {
      const contentWithNewlines = generalInstructions[selectedInstructionLang].replace(/\r?\n/g, "\\n");
      console.log("General Instructions (" + selectedInstructionLang + "):", contentWithNewlines);
    }
    const apiData = {
      timezone: timeZone,
      doctorDailyReport: {
        toggle: doctorDailyReportToggle,
        timing: doctorDailyReportToggle
          ? timezoneTimeToUtc(
              convertTimeTo24(doctorReportTiming) || "",
              timeZone,
              "hh:mm:ss",
              "h:mm a"
            )
          : "11 pm",
      },

      appointmentAndPatientRemainders: {
        doctorAppointmentReminders: {
          toggle: doctorToggle,
          reminder1: doctorToggle ? formatTiming(reminder1) : "OFF",
          reminder2: doctorToggle ? formatTiming(reminder2) : "OFF",
          reminder3: doctorToggle ? formatTiming(reminder3) : "OFF",
        },
        preAppointmentReminder: {
          toggle: preToggle,
          timing: preToggle ? formatTiming(preReminder) : "30 min",
        },
        dayBeforeReminder: {
          toggle: dayBeforeToggle,
          timing: dayBeforeToggle
            ? timezoneTimeToUtc(
                convertTimeTo24(dayBeforeTiming) || "",
                timeZone,
                "hh:mm:ss",
                "h:mm a"
              )
            : "9 pm",
        },
        noShowReminder: {
          toggle: noShowToggle,
          timing: noShowToggle ? formatTiming(noShowReminder) : "30 min",
        },
        followUpReminder: {
          toggle: followUpToggle,
          timing: followUpToggle
            ? timezoneTimeToUtc(
                convertTimeTo24(followUpReminder) || "",
                timeZone,
                "hh:mm:ss",
                "h:mm a"
              )
            : "7 am",
        },
        googleReviewSteps: {
          toggle: googleReviewToggle,
        },
        customGoogleReview: {
          value: customReview,
        },
      },
      operationalEfficiencyAndQueueManagement: {
        dailyOperationalReports: {
          toggle: dailyReportToggle,
          timing: dailyReportToggle
            ? timezoneTimeToUtc(
                convertTimeTo24(dailyReportTiming) || "",
                timeZone,
                "hh:mm:ss",
                "h:mm a"
              )
            : "11 pm",
        },
        doctorDelayCaptureNotify: doctorDelayToggle,
        checkQueueStatus: checkQueueToggle,
        userDistanceCheck: {
          toggle: userDistanceToggle,
          timing: userDistanceToggle
            ? formatTiming(userDistanceTiming)
            : "15 min",
        },
      },
      automatedPatientManagement: {
        autoCompletePatients: {
          toggle: autoCompleteToggle,
          timing: autoCompleteToggle
            ? formatTiming(autoCompleteTiming)
            : "30 min",
        },
      },
      bookingMessages: {
        // confirmWithoutCancel: confirmWithoutCancelToggle,
        appointmentCancellationReason: {
          toggle: appointmentCancellationToggle,
        },
        appointmentReasonCollection: { toggle: appointmentReasonToggle },
        samedayBotbookingDisable: {
          toggle: samedayBotbookingDisableToggle,
          time: samedayBotbookingDisableToggle
            ? timezoneTimeToUtc(
                convertTimeTo24(samedayBotbookingDisableTime) || "",
                timeZone,
                "hh:mm:ss",
                "h:mm a"
              )
            : "8 am",
        },
        unavailableDocMessage: unavailableDocMessageToggle,
      },
      instructionSettings,
    };

    // console.log("Admin panel API data", apiData);

    const response = await putSettingsByHospitalId(hospital_id, apiData);
    if (response.status === 200) {
      console.log("API Data:", apiData);
      toast.success("Changes saved!");
      setIsLoading(false);
    } else {
      console.log("Error:", response);

      toast.error("Failed to save changes. Please try again later");
      setIsLoading(false);
    }
  };

  const convert24To12 = (time24: string) => {
    if (!time24) return "off";
    const [hourStr, minuteStr] = time24.split(":");
    let hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);
    const ampm = hour >= 12 ? "pm" : "am";
    hour = hour % 12;
    if (hour === 0) hour = 12;
    return `${hour}${minute > 0 ? `:${minute}` : ""} ${ampm}`.trim();
  };

  // Fetch settings from backend and set defaults
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await getSettingsByHospitalId(hospital_id);
        console.log("admin panel data", response);
        if (response.status === 200) {
          // Assuming your successResponse wraps data in an array
          const data = response.data.result[0];
          console.log(data);

          // Doctor Appointment Reminders
          setDoctorToggle(
            !!(data.doc_rem_1 || data.doc_rem_2 || data.doc_rem_3)
          );
          setReminder1(data.doc_rem_1 || "OFF");
          setReminder2(data.doc_rem_2 || "OFF");
          setReminder3(data.doc_rem_3 || "OFF");
          setDoctorDailyReportToggle(!!data.doctor_daily_report);
          setDoctorReportTiming(
            data.doctor_daily_report
              ? convert24To12(data.doctor_daily_report)
              : "11 pm"
          );

          setAppointmentCancellationToggle(
            !!data.appointment_cancellation_reason
          );
          setAppointmentReasonToggle(!!data.appointment_reason_collection);
          // Pre-Appointment Reminder
          setPreToggle(!!data.patient_reminder);
          setPreReminder(data.patient_reminder || "30 min");

          // Day-Before Reminder (convert 24-hour time to 12-hour format)
          setDayBeforeToggle(!!data.day_before_reminder);
          setDayBeforeTiming(
            data.day_before_reminder
              ? convert24To12(
                  utcTimeToTimezone(
                    data.day_before_reminder,
                    timeZone,
                    "HH:mm:ss",
                    "HH:mm:ss"
                  )
                )
              : "9 pm"
          );
          // No Show Reminder
          setNoShowToggle(!!data.noshow_reminder);
          setNoShowReminder(data.noshow_reminder || "30 min");
          // Follow-up Reminder (converted to 12-hour if needed)
          setFollowUpToggle(!!data.followup_reminder);
          setFollowUpReminder(
            data.followup_reminder
              ? convert24To12(
                  utcTimeToTimezone(
                    data.followup_reminder,
                    timeZone,
                    "HH:mm:ss",
                    "HH:mm:ss"
                  )
                )
              : "7 am"
          );
          // Daily Operational Reports
          setDailyReportToggle(!!data.report_time);
          setDailyReportTiming(
            data.report_time
              ? convert24To12(
                  utcTimeToTimezone(
                    data.report_time,
                    timeZone,
                    "HH:mm:ss",
                    "HH:mm:ss"
                  )
                )
              : "11 pm"
          );
          // Doctor Delay Updates & Queue Status
          setDoctorDelayToggle(!!data.docdelay_capture_notify);
          setCheckQueueToggle(!!data.check_queue_status);
          // User Distance Check
          setUserDistanceToggle(!!data.patient_distance);
          setUserDistanceTiming(data.patient_distance || "15 min");
          // Automated Patient Management
          setAutoCompleteToggle(!!data.auto_complete);
          setAutoCompleteTiming(
            data.auto_complete ? data.auto_complete : "30 min"
          );
          setTimeZone(data.timezone);
          setGoogleReviewToggle(data.review_steps);
          setCustomReview(data.custom_review);
          // setConfirmWithoutCancelToggle(!!data.confirm_without_cancel);
          setAppointmentCancellationToggle(!!data.cancel_reason_needed);
          setAppointmentReasonToggle(!!data.booking_reason_needed);
          setSamedayBotbookingDisableToggle(!!data.sameday_botbooking_disable_time);
          setSamedayBotbookingDisableTime(
            data.sameday_botbooking_disable_time
              ? convert24To12(
                  utcTimeToTimezone(
                    data.sameday_botbooking_disable_time,
                    timeZone,
                    "HH:mm:ss",
                    "HH:mm:ss"
                  )
                )
              : "8 am"
          );
          setUnavailableDocMessageToggle(!!data.unavailable_doc_message);
          setGeneralInstructionsToggle(!!data.is_instruction_needed);
          setGeneralInstructions(
            data.instruction_content && typeof data.instruction_content === "object"
              ? data.instruction_content
              : { en: "" }
          );
          setSelectedInstructionLang(Object.keys(data.instruction_content || { en: "" })[0] || "en");
          if (data.visit_type_instruction_content && typeof data.visit_type_instruction_content === "object") {
            setVisitTypeInstructions((prev) => ({ ...prev, ...data.visit_type_instruction_content }));
          }

          // Doctor Daily Operational Reports
          setDoctorDailyReportToggle(!!data.doctor_report_time);
          setDoctorReportTiming(
            data.doctor_report_time
              ? convert24To12(
                  utcTimeToTimezone(
                    data.doctor_report_time,
                    timeZone,
                    "HH:mm:ss",
                    "HH:mm:ss"
                  )
                )
              : "11 pm"
          );
        }
      } catch (error) {
        console.error("Error fetching admin settings:", error);
      }
    };
    if (hospital_id) fetchSettings();
  }, [hospital_id]);

  // Helper function to format timing strings (removes extra words)
  const formatTiming = (timing: string | undefined) => {
    if (!timing || timing === "off") return "off";
    const timingStr = String(timing);
    return timingStr
      .replace(/\s*(before|after)\s*/gi, " ")
      .replace(/\s+/g, " ")
      .trim();
  };

  // Update the toggle button styles to include cursor-not-allowed
  const toggleButtonClass = `group peer bg-white rounded-full duration-300 w-14 h-6 ring-[1.5px] ring-[#A6A6A6] 
    after:duration-300 after:bg-[#A6A6A6] peer-checked:after:bg-[#335FE4] peer-checked:ring-[#335FE4] 
    after:rounded-full after:absolute after:h-4 after:w-4 after:top-[4px] after:left-1 
    after:flex after:justify-center after:items-center peer-checked:after:translate-x-8 peer-hover:after:scale-95
    ${!admin_panel ? "opacity-50 cursor-not-allowed pointer-events-none" : ""}`;

  // Update the CustomSelect wrapper class
  const selectWrapperClass = `relative inline-block w-[150px] md:w-[200px] ${
    !admin_panel ? "opacity-50 cursor-not-allowed pointer-events-none" : ""
  }`;

  // Update the save button class
  const saveButtonClass = `bg-blue-500 hover:bg-blue-600 text-white py-2 px-6 rounded-md md:mr-6 mt-4 md:mt-0 mb-4 w-[95%] md:w-48 flex items-center justify-center ${
    isLoading ? "opacity-50 cursor-not-allowed" : ""
  }`;

  const renderBoldPreview = (text: string) => {
    // Replace *text* with <b>text</b>, but do NOT replace newlines
    return text.replace(/\*(.*?)\*/g, '<b>$1</b>');
  };

  // Helper: Static templates for each language
  const instructionTemplates: { [lang: string]: string } = {
    en: `Appointment Instructions\n\nPlease follow the instructions below to prepare for your upcoming appointment:\n\n{{1}}\n\nThank you for your cooperation.`,
    hi: `नियुक्ति निर्देश\n\nकृपया अपनी आगामी नियुक्ति की तैयारी के लिए नीचे दिए गए निर्देशों का पालन करें:\n\n{{1}}\n\nआपके सहयोग के लिए धन्यवाद।`,
    mr: `नियुक्तीच्या सूचना\n\nतुमच्या आगामी अपॉइंटमेंटची तयारी करण्यासाठी कृपया खालील सूचनांचे पालन करा:\n\n{{1}}\n\nतुमच्या सहकार्याबद्दल धन्यवाद.`,
    ta: `நியமன வழிமுறைகள்\n\nஉங்கள் வரவிருக்கும் சந்திப்புக்குத் தயாராவதற்கு கீழே உள்ள வழிமுறைகளைப் பின்பற்றவும்:\n\n{{1}}\n\nஉங்கள் ஒத்துழைப்புக்கு நன்றி.`,
    te: `అపాయింట్‌మెంట్ సూచనలు\n\nమీ రాబోయే అపాయింట్‌మెంట్‌కు సిద్ధం కావడానికి దయచేసి దిగువ సూచనలను అనుసరించండి:\n\n{{1}}\n\nమీ సహకారానికి ధన్యవాదాలు.`,
    kn: `ನೇಮಕಾತಿ ಸೂಚನೆಗಳು\n\nನಿಮ್ಮ ಮುಂಬರುವ ಅಪಾಯಿಂಟ್‌ಮೆಂಟ್‌ಗೆ ಸಿದ್ಧರಾಗಲು ದಯವಿಟ್ಟು ಕೆಳಗಿನ ಸೂಚನೆಗಳನ್ನು ಅನುಸರಿಸಿ:\n\n{{1}}\n\nನಿಮ್ಮ ಸಹಕಾರಕ್ಕಾಗಿ ಧನ್ಯವಾದಗಳು.`,
    ar: `تعليمات الموعد\n\nيرجى اتباع التعليمات التالية للتحضير لموعدك القادم:\n\n{{1}}\n\nشكرًا لتعاونكم.`,
  };

  // Helper: Render static preview with user input
  const renderStaticPreview = (lang: string, userInput: string) => {
    const template = instructionTemplates[lang] || instructionTemplates['en'];
    // Replace newlines with <br> and *bold* with <b>bold</b>
    const replaced = template.replace('{{1}}', userInput || '').replace(/\n/g, '<br>').replace(/\*(.*?)\*/g, '<b>$1</b>');
    return replaced;
  };

  return (
    <div className="w-full h-[100vh] overflow-y-auto side_bar">
      <Header header value={"Admin Panel"} />
      <div className="w-full flex justify-end py-6 px-4">
        <div className="flex items-center gap-4 justify-end">
          <h1 className="text-md font-semibold uppercase w-full">Time zone</h1>
          <div className="flex justify-end relative w-full">
            <CustomSelect
              options={moment.tz.names().filter((tz) => tz.includes("Asia"))}
              value={timeZone}
              onChange={(selectedValue) => {
                if (!admin_panel) {
                  handleDisabledInteraction();
                  return;
                }
                setTimeZone(selectedValue);
                setCookie("timezone", selectedValue, 7);
              }}
            />
          </div>
        </div>
      </div>
      
      {/* Operational Efficiency & Queue Management Section */}
      <div className="flex flex-col bg-white m-4 p-2 rounded-md">
        <h1 className="font-semibold text-blue-800 text-xl md:text-lg">
          Patient Communication & Reminders
        </h1>
        <div className="flex flex-col md:flex-row justify-between mt-4 p-2 md:p-4">
            <div className="flex justify-between">
              <div className="flex flex-col mt-2">
                <h1 className="text-sm md:text-md font-semibold text-gray-900">
                  Request Patient Feedback
                </h1>
                <p className="text-xs md:text-sm text-gray-600">
                   Define when to send review requests post-appointment.
                </p>
                <p className="text-xs md:text-sm text-gray-500 mt-2">
                  Automatically send a review notification to patients after their
                  appointment is marked as complete. Select the desired timing from
                  the dropdown menu.
                </p>
              </div>
            </div>
            <div className="flex flex-col md:flex-row gap-4 items-between m-0 md:m-2">
              <div className="relative w-full">
                <CustomSelect
                  options={["Immediate", "After 2 days", "Both"]}
                  value={
                    customReview === 0
                      ? "Immediate"
                      : customReview === 1
                      ? "After 2 days"
                      : "Both"
                  }
                  onChange={(selectedValue) => {
                    const index = ["Immediate", "After 2 days", "Both"].indexOf(
                      selectedValue
                    );
                    setCustomReview(index);
                  }}
                />
              </div>
            </div>
          </div>
        <hr />
        <div className="flex flex-col md:flex-row justify-between mt-4 p-2 md:p-4">
            <div className="flex justify-between">
              <div className="flex flex-col mt-2">
                <h1 className="text-sm md:text-md font-semibold text-gray-900">
                  Send Pre-Appointment Reminders
                </h1>
                <p className="text-xs md:text-sm text-gray-600">
                   Toggle to activate automated patient reminders.
                </p>
                <p className="text-xs md:text-sm text-gray-500 mt-2">
                  Notify patients about their upcoming appointment. Select how long before the scheduled time this reminder should be sent.
                </p>
              </div>
              <label className="flex relative cursor-pointer top-[8px] md:hidden">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={preToggle}
                  onChange={handlePreToggleChange}
                />
                <div className={toggleButtonClass} />
              </label>
            </div>
            <div className="flex flex-col md:flex-row gap-4 items-between m-0 md:m-2">
              <div className="relative w-full">
                <CustomSelect
                  options={[
                    "15 min",
                    "30 min",
                    "1 hour",
                    "2 hour",
                    "3 hour",
                    "4 hour",
                    "5 hour",
                    "6 hour",
                    "7 hour",
                    "8 hour",
                    "9 hour",
                    "10 hour",
                    "11 hour",
                    "12 hour",
                  ]}
                  value={preReminder}
                  onChange={handlePreReminderChange}
                />
              </div>
              <label className="relative cursor-pointer top-[6px] hidden md:flex">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={preToggle}
                  onChange={handlePreToggleChange}
                />
                <div className={toggleButtonClass} />
              </label>
            </div>
          </div>
          <hr className="border-1.5" />
        {/* Day-Before Patient Reminder Section */}
          <div className="flex flex-col md:flex-row justify-between mt-4 p-2 md:p-4">
            <div className="flex justify-between">
              <div className="flex flex-col mt-2">
                <h1 className="text-sm md:text-md font-semibold text-gray-900">
                  Set a Day-Before Reminder
                </h1>
                <p className="text-xs md:text-sm text-gray-600">
                  Specify a time to remind patients on the eve of their appointment.
                </p>
                <p className="text-xs md:text-sm text-gray-500 mt-2">
                  Send an additional reminder to patients at a set time on the day before their scheduled appointment.
                </p>
              </div>
              <label className="relative cursor-pointer top-[8px] flex md:hidden">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={dayBeforeToggle}
                  onChange={handleDayBeforeToggleChange}
                />
                <div className={toggleButtonClass} />
              </label>
            </div>
            <div className="flex flex-col md:flex-row gap-4 items-between m-0 md:m-2">
              <div className="relative w-full">
                <CustomSelect
                  options={[
                    "1 am",
                    "2 am",
                    "3 am",
                    "4 am",
                    "5 am",
                    "6 am",
                    "7 am",
                    "8 am",
                    "9 am",
                    "10 am",
                    "11 am",
                    "12 am",
                    "1 pm",
                    "2 pm",
                    "3 pm",
                    "4 pm",
                    "5 pm",
                    "6 pm",
                    "7 pm",
                    "8 pm",
                    "9 pm",
                    "10 pm",
                    "11 pm",
                    "12 pm",
                  ]}
                  value={dayBeforeTiming}
                  onChange={handleDayBeforeTimingChange}
                />
              </div>
              <label className=" relative cursor-pointer top-[6px] hidden md:flex">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={dayBeforeToggle}
                  onChange={handleDayBeforeToggleChange}
                />
                <div className={toggleButtonClass} />
              </label>
            </div>
          </div>
          <hr className="border-1.5" />

          {/* No Show Reminder After Session End */}
          <div className="flex flex-col md:flex-row justify-between mt-4 p-2 md:p-4">
            <div className="flex justify-between">
              <div className="flex flex-col mt-2">
                <h1 className="text-sm md:text-md font-semibold text-gray-900">
                  Follow Up with No-Shows
                </h1>
                <p className="text-xs md:text-sm text-gray-600">
                  Automate outreach to patients who missed their appointments.
                </p>
                <p className="text-xs md:text-sm text-gray-500 mt-2">
                  Automatically send a notification to patients marked as "No Show" after their scheduled session time has passed. Select the delay for this follow-up message
                </p>
              </div>
              <label className="relative cursor-pointer top-[8px] flex md:hidden">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={noShowToggle}
                  onChange={handleNoShowToggleChange}
                />
                <div className={toggleButtonClass} />
              </label>
            </div>
            <div className="flex flex-col md:flex-row gap-4 items-between m-0 md:m-2">
              <div className="relative w-full">
                <CustomSelect
                  options={[
                    "15 min",
                    "30 min",
                    "1 hour",
                    "2 hour",
                    "3 hour",
                    "4 hour",
                    "5 hour",
                    "6 hour",
                    "7 hour",
                    "8 hour",
                    "9 hour",
                    "10 hour",
                    "11 hour",
                    "12 hour",
                  ]}
                  value={noShowReminder}
                  onChange={handleNoShowReminderChange}
                />
              </div>
              <label className="relative cursor-pointer top-[6px] hidden md:flex">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={noShowToggle}
                  onChange={handleNoShowToggleChange}
                />
                <div className={toggleButtonClass} />
              </label>
            </div>
          </div>
          <hr className="border-1.5" />

          <div className="flex flex-col md:flex-row justify-between mt-4 p-2 md:p-4">
            <div className="flex justify-between">
              <div className="flex flex-col mt-2">
                <h1 className="text-sm md:text-md font-semibold text-gray-900">
                  Send Day-of-Appointment Reminders
                </h1>
                <p className="text-xs md:text-sm text-gray-600">
                  Set a daily time to remind all patients scheduled for that day.
                </p>
                <p className="text-xs md:text-sm text-gray-500 mt-2">
                  Send a single reminder at a specific time (e.g., in the morning) to all patients who have an appointment scheduled for the current day.
                </p>
              </div>
              <label className="relative cursor-pointer top-[8px] flex md:hidden">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={followUpToggle}
                  onChange={handleFollowUpToggleChange}
                />
                <div className={toggleButtonClass} />
              </label>
            </div>
            <div className="flex flex-col md:flex-row gap-4 items-between m-0 md:m-2">
              <div className="relative w-full">
                <CustomSelect
                  options={[
                    "1 am",
                    "2 am",
                    "3 am",
                    "4 am",
                    "5 am",
                    "6 am",
                    "7 am",
                    "8 am",
                    "9 am",
                    "10 am",
                    "11 am",
                    "12 am",
                    "1 pm",
                    "2 pm",
                    "3 pm",
                    "4 pm",
                    "5 pm",
                    "6 pm",
                    "7 pm",
                    "8 pm",
                    "9 pm",
                    "10 pm",
                    "11 pm",
                    "12 pm",
                  ]}
                  value={followUpReminder}
                  onChange={handleFollowUpReminderChange}
                />
              </div>
              <label className="relative cursor-pointer top-[6px] hidden md:flex">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={followUpToggle}
                  onChange={handleFollowUpToggleChange}
                />
                <div className={toggleButtonClass} />
              </label>
            </div>
          </div>
          <hr className="border-1.5" />

          <div className="flex flex-row justify-between mt-4 p-2 md:p-4">
            <div className="flex flex-col mt-2">
              <h1 className="text-sm md:text-md font-semibold">
                Manage Google Review Requests
              </h1>
              <p className="text-xs md:text-sm text-gray-600">
                  Strategically request Google reviews based on internal feedback.
                </p>
                <p className="text-xs md:text-sm text-gray-500 mt-2">
                  After a patient provides internal feedback (e.g., a 1-5 star rating), this system will only send a Google review notification to those who rate their experience highly (e.g., 4 or 5 stars). Notifications are not sent for low ratings.
                </p>
            </div>
            <label className="flex relative cursor-pointer top-[8px] md:top-[6px]">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={googleReviewToggle}
                onChange={handleGoogleReviewToggleChange}
              />
              <div className={toggleButtonClass} />
            </label>
          </div>          
      </div>
      {/* Automated Patient Management Section */}
      <div className="flex flex-col bg-white m-4 p-2 rounded-md">
        <h1 className="font-semibold text-blue-800 text-xl md:text-lg">
          Staff & Admin Notifications
        </h1>
        <div className="flex flex-col gap-2">
          {/* Doctor Appointment Reminders Section */}
            <div className="flex justify-between mt-4">
              <div className="flex flex-col mt-2">
                <h1 className="text-sm md:text-md font-semibold">
                  Send Appointment Reminders to Doctors
                </h1>
                <p className="text-xs md:text-sm text-gray-500 mt-2">
                  Help doctors stay on schedule by sending them reminders before each appointment. You can set up to 3 separate reminders
                </p>
              </div>
              <label className="flex relative cursor-pointer top-[8px] md:top-[6px]">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={doctorToggle}
                  onChange={handleDoctorToggleChange}
                />
                <div className={toggleButtonClass} />
              </label>
            </div>
            <div className="bg-[#F6F6F6] flex flex-col md:flex-row gap-6 md:gap-8 p-4 rounded-md">
              {/* Reminder 1 */}
              <div className="w-full">
                <p className="font-light text-modalText text-sm mb-2">
                  First Reminder
                </p>
                <div className="relative w-full">
                  <CustomSelect
                    options={[
                      "OFF",
                      "15 min",
                      "30 min",
                      "1 hour",
                      "2 hour",
                      "3 hour",
                      "4 hour",
                      "5 hour",
                      "6 hour",
                      "7 hour",
                      "8 hour",
                      "9 hour",
                      "10 hour",
                      "11 hour",
                      "12 hour",
                    ]}
                    value={reminder1}
                    onChange={handleReminder1Change}
                    className={selectWrapperClass}
                  />
                </div>
              </div>
              {/* Reminder 2 */}
              <div className="w-full">
                <p className="font-light text-modalText text-sm mb-2">
                  Second Reminder
                </p>
                <div className="relative w-full">
                  <CustomSelect
                    options={[
                      "OFF",
                      "15 min",
                      "30 min",
                      "1 hour",
                      "2 hour",
                      "3 hour",
                      "4 hour",
                      "5 hour",
                      "6 hour",
                      "7 hour",
                      "8 hour",
                      "9 hour",
                      "10 hour",
                      "11 hour",
                      "12 hour",
                    ]}
                    value={reminder2}
                    onChange={handleReminder2Change}
                    className={selectWrapperClass}
                  />
                </div>
              </div>
              {/* Reminder 3 */}
              <div className="w-full">
                <p className="font-light text-modalText text-sm mb-2">
                  Third Reminder
                </p>
                <div className="relative w-full">
                  <CustomSelect
                    options={[
                      "OFF",
                      "15 min",
                      "30 min",
                      "1 hour",
                      "2 hour",
                      "3 hour",
                      "4 hour",
                      "5 hour",
                      "6 hour",
                      "7 hour",
                      "8 hour",
                      "9 hour",
                      "10 hour",
                      "11 hour",
                      "12 hour",
                    ]}
                    value={reminder3}
                    onChange={handleReminder3Change}
                    className={selectWrapperClass}
                  />
                </div>
              </div>
            </div>
            <hr/>
            <div className="flex flex-col md:flex-row justify-between mt-4 p-2 md:p-4">
              <div className="flex justify-between">
                <div className="flex flex-col mt-2">
                  <h1 className="text-sm md:text-md font-semibold">
                    Send Daily Reports to doctors
                  </h1>
                  <p className="text-xs md:text-sm text-gray-600 mt-1">
                    Provide doctors a daily overview of activities.
                  </p>
                  <p className="text-xs md:text-sm text-gray-500 mt-2">
                    Provide doctors with a daily overview of their patient interactions and activities. Select a time for this report to be sent.
                  </p>
                </div>
                <label className="relative cursor-pointer top-[8px] flex md:hidden">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={dailyReportToggle}
                    onChange={handleDailyReportToggleChange}
                  />
                  <div className={toggleButtonClass} />
                </label>
              </div>
              <div className="flex flex-col md:flex-row gap-4 items-between m-0 md:m-2">
                <div className="relative w-full">
                  <CustomSelect
                    options={["7 pm", "8 pm", "9 pm", "10 pm", "11 pm"]}
                    value={doctorReportTiming}
                    onChange={handleDoctorReportTimingChange}
                  />
                </div>
                <label className="relative cursor-pointer top-[6px] hidden md:flex">
                  <input
                    type="checkbox"
                    className="sr-only peer"
                    checked={doctorDailyReportToggle}
                    onChange={handleDoctorDailyReportToggleChange}
                  />
                  <div className={toggleButtonClass} />
                </label>
              </div>
        </div>
      </div>
        <hr className="border-1.5" />
      {/* Daily Operational Reports */}
          <div className="flex flex-col md:flex-row justify-between mt-4 p-2 md:p-4">
            <div className="flex justify-between">
              <div className="flex flex-col mt-2">
                <h1 className="text-sm md:text-md font-semibold">
                  Send Admin Operational Reports
                </h1>
                <p className="text-xs md:text-sm text-gray-600 mt-1">
                  Generate daily reports for hospital staff workflow tracking.
                </p>
                <p className="text-xs md:text-sm text-gray-500 mt-2">
                  Generate daily reports for hospital staff at a scheduled time for better workflow tracking and end-of-day reconciliation.
                </p>
                <p className="text-xs md:text-sm text-[#8A8A8A] mb-2">
                  Generate daily reports at scheduled times for better hospital
                  workflow tracking.
                </p>
              </div>
              <label className="relative cursor-pointer top-[8px] flex md:hidden">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={dailyReportToggle}
                  onChange={handleDailyReportToggleChange}
                />
                <div className={toggleButtonClass} />
              </label>
            </div>
            <div className="flex flex-col md:flex-row gap-4 items-between m-0 md:m-2">
              <div className="relative w-full">
                <CustomSelect
                  options={[
                    "1 am",
                    "2 am",
                    "3 am",
                    "4 am",
                    "5 am",
                    "6 am",
                    "7 am",
                    "8 am",
                    "9 am",
                    "10 am",
                    "11 am",
                    "12 am",
                    "1 pm",
                    "2 pm",
                    "3 pm",
                    "4 pm",
                    "5 pm",
                    "6 pm",
                    "7 pm",
                    "8 pm",
                    "9 pm",
                    "10 pm",
                    "11 pm",
                    "12 pm",
                  ]}
                  value={dailyReportTiming}
                  onChange={handleDailyReportTimingChange}
                />
              </div>
              <label className="relative cursor-pointer top-[6px] hidden md:flex">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={dailyReportToggle}
                  onChange={handleDailyReportToggleChange}
                />
                <div className={toggleButtonClass} />
              </label>
            </div>
          </div>
        <hr className="border-1.5" />
          <div className="flex flex-col gap-2">
          
          {/* User Distance Check */}
          {/* <div className="flex flex-col md:flex-row justify-between mt-4 p-2 md:p-4">
            <div className="flex justify-between">
              <div className="flex flex-col mt-2">
                <h1 className="text-sm md:text-md font-semibold">
                  User Distance Check
                </h1>
                <p className="text-xs md:text-sm text-[#8A8A8A] mb-2">
                  Monitor patient location status before their scheduled
                  appointment.
                </p>
              </div>
              <label className="relative cursor-pointer top-[8px] flex md:hidden">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={userDistanceToggle}
                  onChange={handleUserDistanceToggleChange}
                />
                <div
                  className="group peer bg-white rounded-full duration-300 w-14 h-6 ring-[1.5px] ring-[#A6A6A6] 
                    after:duration-300 after:bg-[#A6A6A6] peer-checked:after:bg-[#335FE4] peer-checked:ring-[#335FE4] 
                    after:rounded-full after:absolute after:h-4 after:w-4 after:top-[4px] after:left-1 
                    after:flex after:justify-center after:items-center peer-checked:after:translate-x-8 peer-hover:after:scale-95"
                />
              </label>
            </div>
            <div className="flex flex-col md:flex-row gap-4 items-between m-0 md:m-2">
              <div className="relative w-full">
                <CustomSelect
                  options={[
                    "15 min",
                    "30 min",
                    "1 hour",
                    "2 hour",
                    "3 hour",
                    "4 hour",
                    "5 hour",
                    "6 hour",
                    "7 hour",
                    "8 hour",
                    "9 hour",
                    "10 hour",
                    "11 hour",
                    "12 hour",
                  ]}
                  value={userDistanceTiming}
                  onChange={handleUserDistanceTimingChange}
                />
              </div>
              <label className="relative cursor-pointer top-[6px] hidden md:flex">
                <input
                  type="checkbox"
                  className="sr-only peer"
                  checked={userDistanceToggle}
                  onChange={handleUserDistanceToggleChange}
                />
                <div
                  className="group peer bg-white rounded-full duration-300 w-14 h-6 ring-[1.5px] ring-[#A6A6A6] 
                    after:duration-300 after:bg-[#A6A6A6] peer-checked:after:bg-[#335FE4] peer-checked:ring-[#335FE4] 
                    after:rounded-full after:absolute after:h-4 after:w-4 after:top-[4px] after:left-1 
                    after:flex after:justify-center after:items-center peer-checked:after:translate-x-8 peer-hover:after:scale-95"
                />
              </label>
            </div>
          </div>
          <hr /> */}

          <hr />
        </div>
        {/* Doctor Delay Updates */}
        <div className="flex flex-row justify-between mt-4 p-2 md:p-4">
          <div className="flex flex-col mt-2">
            <h1 className="text-sm md:text-md font-semibold text-gray-800">
              Notify on Doctor Delays
            </h1>
            <p className="text-xs md:text-sm text-gray-600 mt-1 leading-relaxed">
              Inform patients and staff about doctor delays.
            </p>
            <p className="text-xs text-gray-500 mt-2 leading-relaxed">
              Automatically notify staff and waiting patients when a doctor is delayed, helping to manage expectations.
            </p>
          </div>
          <label className="flex relative cursor-pointer  top-[8px] md:top-[6px]">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={doctorDelayToggle}
              onChange={handleDoctorDelayToggleChange}
            />
            <div className={toggleButtonClass} />
          </label>
        </div>
      </div>
      <div className="flex flex-col bg-white m-4 p-2 rounded-md">
        <h1 className="font-semibold text-blue-800 text-xl md:text-lg">
          Clinic Operations & Automation
        </h1>
        {/* <div className="flex flex-row justify-between mt-4 p-2 md:p-4">
          <div className="flex flex-col mt-2">
            <h1 className="text-sm md:text-md font-semibold">
              Appointment confirmation without cancel
            </h1>
            <p className="text-xs md:text-sm text-[#8A8A8A] mb-2">
              Sending appointment confirmation template without cancel button.
            </p>
          </div>
          <label className="flex relative cursor-pointer  top-[8px] md:top-[6px]">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={confirmWithoutCancelToggle}
              onChange={handleAppointmentWithoutCancelToggleChange}
            />
            <div
              className={toggleButtonClass}
            />
          </label>
        </div> */}
          {/* Check Queue Status */}
          <div className="flex flex-row justify-between mt-4 p-2 md:p-4">
            <div className="flex flex-col mt-2">
              <h1 className="text-sm md:text-md font-semibold">
                Automate in-clinic queue status
              </h1>
              <p className="text-xs md:text-sm text-gray-600 mt-1">
                Automate queue checks to manage patient flow efficiently.
              </p>
              <p className="text-xs md:text-sm text-gray-500 mt-2">
                Automatically check and update the in-clinic queue status at regular intervals (e.g., every 30 minutes) to help manage patient flow efficiently.
              </p>
            </div>
            <label className="flex relative cursor-pointer top-[8px] md:top-[6px]">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={checkQueueToggle}
                onChange={handleCheckQueueToggleChange}
              />
              <div className={toggleButtonClass} />
            </label>
          </div>
          <hr />
        <div className="flex flex-col md:flex-row justify-between mt-4 p-2 md:p-4">
          <div className="flex justify-between">
            <div className="flex flex-col mt-2">
              <h1 className="text-sm md:text-md font-semibold">
                Auto-complete In-clinic Patients After Session Ends
              </h1>
              <p className="text-xs md:text-sm text-gray-600 mt-1">
                Mark in-clinic patients as completed post-session automatically.
              </p>
              <p className="text-xs md:text-sm text-gray-500 mt-2">
                Maintain accurate records by automatically marking in-clinic patients as "completed" after a set time has passed since their session.
              </p>
            </div>
            <label className="flex relative cursor-pointer top-[10px] md:top-[6px] md:hidden">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={autoCompleteToggle}
                onChange={handleAutoCompleteToggleChange}
              />
              <div className={toggleButtonClass} />
            </label>
          </div>
          <div className="flex flex-col md:flex-row gap-4 items-between m-0 md:m-2">
            <CustomSelect
              options={[
                "1 hour",
                "2 hour",
                "3 hour",
                "4 hour",
                "5 hour",
                "6 hour",
              ]}
              value={autoCompleteTiming}
              onChange={handleAutoCompleteTimingChange}
            />
            <label className="hidden relative cursor-pointer top-[10px] md:top-[6px] md:flex">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={autoCompleteToggle}
                onChange={handleAutoCompleteToggleChange}
              />
              <div className={toggleButtonClass} />
            </label>
          </div>
        </div>
      </div>

      <div className="flex flex-col bg-white m-4 p-2 rounded-md">
        <h1 className="font-semibold text-blue-800 text-xl md:text-lg">
          General Settings
        </h1>
        <div className="flex flex-row justify-between mt-4 p-2 md:p-4">
          <div className="flex flex-col mt-2">
            <h1 className="text-sm md:text-md font-semibold">
              Appointment cancellation reason collection
            </h1>
            <p className="text-xs md:text-sm text-gray-600 mt-1">
              Require patients to provide a reason when cancelling.
            </p>
            <p className="text-xs md:text-sm text-gray-500 mt-2">
              Require patients to provide a reason for cancelling. This data is crucial for improving scheduling and reducing cancellations.
            </p>
          </div>
          <label className="flex relative cursor-pointer  top-[8px] md:top-[6px]">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={appointmentCancellationToggle}
              onChange={handleAppointmentCancellationToggleChange}
            />
            <div className={toggleButtonClass} />
          </label>
        </div>
        <div className="flex flex-row justify-between mt-4 p-2 md:p-4">
          <div className="flex flex-col mt-2">
            <h1 className="text-sm md:text-md font-semibold">
              Appointment reason collection
            </h1>
            <p className="text-xs md:text-sm text-gray-600 mt-1">
              Gather reasons for appointments during booking.
            </p>
            <p className="text-xs md:text-sm text-gray-500 mt-2">
              Gather reasons for appointments during the booking process. This helps optimize scheduling and service delivery.
            </p>
          </div>
          <label className="flex relative cursor-pointer  top-[8px] md:top-[6px]">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={appointmentReasonToggle}
              onChange={handleAppointmentReasonToggleChange}
            />
            <div className={toggleButtonClass} />
          </label>
        </div>

        <hr className="border-1.5" />
        <div className="flex flex-col md:flex-row justify-between mt-4 p-2 md:p-4">
          <div className="flex justify-between">
            <div className="flex flex-col mt-2">
              <h1 className="text-sm md:text-md font-semibold">
                Disable Same Day Bot Booking
              </h1>
              <p className="text-xs md:text-sm text-gray-600 mt-1 leading-relaxed">
                 Disable bot booking for same-day appointments after a specified time.
              </p>
              <p className="text-xs text-gray-500 mt-2 leading-relaxed">
                 Prevent last-minute appointments by disabling the booking bot for same-day appointments after a specified time.
              </p>
            </div>
          </div>
          <div className="flex flex-col md:flex-row gap-4 items-between m-0 md:m-2">
            <div className="relative w-full">
              <CustomSelect
                options={samedayBotbookingDisableTimeOptions}
                value={samedayBotbookingDisableTime}
                onChange={handleSamedayBotbookingDisableTimeChange}
              />
            </div>
            <label className="relative cursor-pointer top-[6px] hidden md:flex">
              <input
                type="checkbox"
                className="sr-only peer"
                checked={samedayBotbookingDisableToggle}
                onChange={handleSamedayBotbookingDisableToggleChange}
              />
              <div
                className={toggleButtonClass}
              />
            </label>
          </div>
        </div>

        <hr className="border-1.5" />
        <div className="flex flex-row justify-between mt-4 p-2 md:p-4">
          <div className="flex flex-col mt-2">
            <h1 className="text-sm md:text-md font-semibold">
              Unavailable popular Doctors Message
            </h1>
            <p className="text-xs md:text-sm text-gray-600 mt-1 leading-relaxed">
              Inform patients if top doctors are unavailable during booking.
            </p>
            <p className="text-xs text-gray-500 mt-2 leading-relaxed">
             Proactively inform patients during booking if any of the hospital's top 5 most-booked doctors are unavailable that day.
            </p>
          </div>
          <label className="flex relative cursor-pointer top-[8px] md:top-[6px]">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={unavailableDocMessageToggle}
              onChange={handleUnavailableDocMessageToggleChange}
            />
            <div
              className={toggleButtonClass}
            />
          </label>
        </div>

        <hr className="border-1.5" />
        <div className="flex flex-row justify-between mt-4 p-2 md:p-4">
          <div className="flex flex-col mt-2">
            <h1 className="text-sm md:text-md font-semibold">
              General Instructions
            </h1>
            <p className="text-xs md:text-sm text-[#8A8A8A] mb-2">
              Send general instructions to patients via WhatsApp. Enable to customize language and content.
            </p>
          </div>
          <label className="flex relative cursor-pointer top-[8px] md:top-[6px]">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={generalInstructionsToggle}
              onChange={() => setGeneralInstructionsToggle((prev) => !prev)}
            />
            <div className={toggleButtonClass} />
          </label>
        </div>
        {generalInstructionsToggle && (
          <>
            {/* General instruction */}
            <div className="flex flex-col md:flex-row gap-4 items-between m-0 md:m-2 mb-4">
              <div className="relative w-full md:w-1/4">
                <CustomSelect
                  options={["en", "hi", "mr", "ta", "te", "kn"]}
                  value={selectedInstructionLang}
                  onChange={setSelectedInstructionLang}
                  className={selectWrapperClass}
                />
                <p className="text-sm text-gray-500 mt-2">
                  To bold any word enclose it in '*' (*example*)<br/>
                  <span className="text-xs">(ISO 639-1 codes: en=English, hi=Hindi, mr=Marathi, ta=Tamil, te=Telugu, kn=Kannada)</span>
                </p>
              </div>
              <div className="relative w-full flex gap-3 md:w-3/4">
                <textarea
                  ref={textareaRef}
                  className="w-1/2 min-h-[80px] border border-gray-300 rounded-md p-2 text-sm resize-none overflow-hidden"
                  placeholder="Write your instructions here..."
                  value={generalInstructions[selectedInstructionLang] || ""}
                  onChange={handleTextareaChange}
                  onKeyDown={handleTextareaKeyDown}
                  onPaste={handleTextareaPaste}
                  rows={1}
                  disabled={!admin_panel}
                />
                <div className="w-1/2 h-full p-2 bg-gray-50 border border-gray-200 rounded text-sm">
                  <span className="font-semibold text-gray-600">Preview:</span>
                  <div
                    className="mt-1"
                    dangerouslySetInnerHTML={{ __html: renderStaticPreview(selectedInstructionLang, generalInstructions[selectedInstructionLang] || "") }}
                  />
                </div>
              </div>
            </div>

            {/* Visit Type Instructions */}
            <div className="border-t border-gray-100 mx-2 md:mx-4" />
            <p className="text-xs md:text-sm font-medium text-gray-600 m-2 md:m-4 mb-2">
              Visit Type Specific Instructions <span className="text-gray-400 font-normal">(optional — overrides general instruction per visit type)</span>
            </p>
            <div className="flex flex-col md:flex-row gap-4 items-start m-0 md:m-2 mb-4">
              <div className="relative w-full md:w-1/4 flex flex-col gap-2">
                <select
                  className="w-full border border-gray-300 rounded-md p-2 text-sm bg-white"
                  value={selectedVisitType}
                  onChange={(e) => setSelectedVisitType(e.target.value)}
                >
                  {visitTypes.map((vt) => (
                    <option key={vt} value={vt}>{visitTypeLabels[vt]}</option>
                  ))}
                </select>
                <CustomSelect
                  options={["en", "hi", "mr", "ta", "te", "kn"]}
                  value={selectedVTLang}
                  onChange={setSelectedVTLang}
                  className={selectWrapperClass}
                />
                <p className="text-xs text-gray-400">Max 200 chars</p>
              </div>
              <div className="relative w-full flex gap-3 md:w-3/4">
                <textarea
                  className="w-1/2 min-h-[80px] border border-gray-300 rounded-md p-2 text-sm resize-none"
                  placeholder={`Instructions for ${visitTypeLabels[selectedVisitType]}...`}
                  value={visitTypeInstructions[selectedVTLang]?.[selectedVisitType] || ""}
                  onChange={(e) => {
                    const val = e.target.value.replace(/[\r\n]+/g, " ").slice(0, 200);
                    setVisitTypeInstructions((prev) => ({
                      ...prev,
                      [selectedVTLang]: {
                        ...(prev[selectedVTLang] || {}),
                        [selectedVisitType]: val,
                      },
                    }));
                  }}
                  onKeyDown={(e) => { if (e.key === "Enter") e.preventDefault(); }}
                  rows={3}
                  disabled={!admin_panel}
                />
                <div className="w-1/2 p-2 bg-gray-50 border border-gray-200 rounded text-sm">
                  <span className="font-semibold text-gray-600">Preview:</span>
                  <div
                    className="mt-1"
                    dangerouslySetInnerHTML={{
                      __html: renderStaticPreview(
                        selectedVTLang,
                        visitTypeInstructions[selectedVTLang]?.[selectedVisitType] || ""
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}

      </div>

      {/* Save Button */}
      <div className="flex justify-center md:justify-end m-2 md:m-4">
        <button onClick={handleSave} className={saveButtonClass}>
          {isLoading ? (
            <>
              <svg
                className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  className="opacity-25"
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  className="opacity-75"
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
            </>
          ) : (
            "Save Changes"
          )}
        </button>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default AdminPanel;
